<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px"
        :rules="rules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="籍贯" prop="jiguan"><el-input v-model="formParameter.jiguan"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="性别" prop="sex"><el-input v-model="formParameter.sex"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证" prop="idno"><el-input v-model="formParameter.idno"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="毕业学校" prop="school"><el-input v-model="formParameter.school"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="学历" prop="xueli">
              <el-select v-model="formParameter.xueli" placeholder="请选择">
                <el-option v-for="item in ['大专', '本科', '低学历', '高学历']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="专业" prop="subject"><el-input v-model="formParameter.subject"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="毕业时间" prop="gradedate">
              <el-date-picker v-model="formParameter.gradedate" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="报读课程" prop="post">
              <el-select v-model="formParameter.post" placeholder="请选择">
                <el-option v-for="item in ['全栈','前端', '后端']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="缴费报名" prop="bmtm">

              <el-date-picker v-model="formParameter.bmtm" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          
        </el-row>

        <el-row>
         
          <el-col :span="6">
            <el-form-item label="交费方式" prop="bmffs">
              
              <el-select v-model="formParameter.bmffs" placeholder="请选择">
                <el-option v-for="item in ['一次性现金', '学贷', '分期']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="总学费" prop="costs"><el-input v-model="formParameter.costs"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="已交学费" prop="paied"><el-input v-model="formParameter.paied"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="入账账户" prop="cpttpname">     
              <el-select v-model="formParameter.cpttpname" placeholder="请选择">
                <el-option v-for="item in cwcnts" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="学费说明" prop="bmtremark"><el-input v-model="formParameter.bmtremark"
              placeholder="定位费500带证书"  autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        
        <el-row v-show="formParameter.bmffs == '学贷'">
          <el-col :span="6">
            <el-form-item label="帮还补贴" prop="bhbt">
              <el-select v-model="formParameter.bhbt" placeholder="帮还期数">
                <el-option v-for="item in [
    '0',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '3',
    '2',
    '1',
  ]" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item v-show="formParameter.bhbt && formParameter.bhbt > 0" label="首次帮还" prop="bhtm">
              <el-date-picker v-model="formParameter.bhtm" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item v-show="formParameter.bhbt && formParameter.bhbt > 0" label="每期帮还" prop="bhcost"><el-input
                placeholder="帮还金额" v-model="formParameter.bhcost" autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <!--el-row>
          <el-col :span="6">
            <el-form-item label="住宿补贴" prop="zsbt">
              <el-select v-model="formParameter.zsbt" placeholder="住宿期数">
                <el-option v-for="item in ['0', '4', '5', '6', '3', '2', '1']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item v-show="formParameter.zsbt && formParameter.zsbt > 0" label="入住日期" prop="zstm">
              <el-date-picker v-model="formParameter.zstm" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item v-show="formParameter.zsbt && formParameter.zsbt > 0" label="每期金额" prop="zscost"><el-input
                placeholder="住宿补贴" v-model="formParameter.zscost" autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        < el-row>
          <el-col :span="6">
            <el-form-item label="学习补贴" prop="xxbt">
              <el-select v-model="formParameter.xxbt" placeholder="补贴期数">
                <el-option v-for="item in ['0', '4', '5', '6', '3', '2', '1']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item v-show="formParameter.xxbt && formParameter.xxbt > 0" label="首次补贴" prop="xxbttm">
              <el-date-picker v-model="formParameter.xxbttm" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker></el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item v-show="formParameter.xxbt && formParameter.xxbt > 0" label="每期金额" prop="xxcost"><el-input
                placeholder="补贴金额" v-model="formParameter.xxcost" autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row-->
        <el-row>
          <el-col :span="8">
            <div style=" font-weight: bold;">上传头像:</div>
            <image-upload v-model="formParameter.head" model="fileSystem" uri="/statics/stu" :size=128 />
            <br />
          </el-col>
          <el-col :span="8">
            <div style=" font-weight: bold;">上传课程申请表:</div>
            <image-upload v-model="formParameter.kcsqb" model="fileSystem" uri="/statics/stu" :size=2048 />
            <br />
          </el-col>
          <el-col :span="8" v-show="formParameter.type == '招转' || formParameter.type == '校招'">
            <div style=" font-weight: bold;">原始求职(多页请合拍):</div>
            <image-upload v-model="formParameter.jianli" model="fileSystem" uri="/statics/stu" :size=2048 />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="沟通能力" prop="pjtxt1">
              <el-select v-model="formParameter.pjtxt1" placeholder="请选择">
                <el-option v-for="item in ['中等', '良好', '较差', '优秀']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="智力评价" prop="pjtxt2">
              <el-select v-model="formParameter.pjtxt2" placeholder="请选择">
                <el-option v-for="item in ['中等', '良好', '较差', '优秀']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="情商评价" prop="pjtxt3"><el-input placeholder="请客观评价" v-model="formParameter.pjtxt3"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark"><el-input type="textarea" rows="2" v-model="formParameter.remark"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/stu/stu.js";
import imageUpload from '@/components/biz/imageUpload/imageUpload.vue';
import fileUpload from '@/components/biz/fileUpload/fileUpload.vue';

export default {
  name: "add",
  components: {
    popup,
    imageUpload,
    fileUpload
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      formParameter: {},
      cwcnts: ['新升基本户公账', '公司_私账', '杨昊_私账'],
      rules: {
        //性别
        sex: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          }
        ],
        //学历
        xueli: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          }
        ],
        //专业
        subject: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: "blur",
          },
        ],
        //报名时间
        bmtm: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          }
        ],
        //报名交费方式：一次性，学贷，分期
        bmffs: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          }
        ],
        //学费金额  
        costs: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          }
        ],
        //已缴费金额  
        paied: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          }
        ]
      },
    };
  },
  methods: {
    //打开弹框
    open(parameter, title, disabled, size) {
      this.formParameter = parameter;
      this.formParameter.consu = parameter.id
      this.formParameter.school = parameter.schoolid
      this.formParameter.xueli = parameter.grade

      this.formParameter.bhbt = 0
      this.formParameter.zsbt = 0
      this.formParameter.xxbt = 0
      
      delete this.formParameter.crer
      delete this.formParameter.crtm
      delete this.formParameter.mder
      delete this.formParameter.mdtm
      delete this.formParameter.dbColumn_mder
      delete this.formParameter.dyer
      delete this.formParameter.age
      delete this.formParameter.rank
      delete this.formParameter.id
      delete this.formParameter.schoolid
      delete this.formParameter.grade

      this.formParameter.pjname1 = '沟通能力'
      this.formParameter.pjname2 = '智力评价'
      this.formParameter.pjname3 = '情商评价'

      this.disabled = disabled;
      this.$refs.popup.open(title, "60%");

    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;

        //添加
        let parameter = this.$utils.merger(this.formParameter);
        api.save(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.close();
            //this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },

  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
